import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { Construction } from '@mui/icons-material';
import { surface, brand, ink, line } from '../../theme/tokens';

const PlaceholderPage = ({ 
  title = "Coming Soon", 
  description = "This feature is currently under development.", 
  icon: Icon = Construction 
}) => {
  return (
    <Box sx={{ 
      flexGrow: 1, 
      p: { xs: 2, md: 3 }, 
      bgcolor: surface.sunken, 
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <Card sx={{ 
        maxWidth: 400, 
        textAlign: 'center',
        backgroundColor: 'white',
        border: `1px solid ${line.default}`,
        boxShadow: 2
      }}>
        <CardContent sx={{ p: 4 }}>
          <Icon sx={{ fontSize: 64, color: brand.mustardInk, mb: 2 }} />
          <Typography variant="h4" sx={{ 
            fontWeight: 'bold', 
            mb: 2, 
            color: ink.primary 
          }}>
            {title}
          </Typography>
          <Typography variant="body1" sx={{ 
            color: ink.secondary, 
            mb: 2 
          }}>
            {description}
          </Typography>
          <Typography variant="caption" sx={{ 
            color: ink.muted 
          }}>
            Please check back later for updates.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PlaceholderPage;